<template>
  <div class="kanit consign-address line-template-consign">
        <b-alert 
            :show="dismissCountDown"
            @dismiss-count-down="countDownChanged"
            >
                <i class="fas fa-exclamation-circle"></i>
                {{ messageAlert }}
        </b-alert>
    <div v-if="Page.one === true" class="d-flex flex-column justify-content-between h-600px">
        <div class="px-3 group-input">
            <div class="form-color-input">
                <label class="label-primary" for="namelastname">ชื่อ-นามสกุล</label>
                <b-form-input type="text" placeholder="กรอกชื่อของคุณ" v-model="inputGroup.name" :class="{ 'is-invalid': $v.inputGroup.name.$error }"/>
                <div v-if="$v.inputGroup.name.$error">
                    <p v-if="!$v.inputGroup.name.required" class="invalid-feedback d-block">กรุณากรอกชื่อ-นามสกุล</p>
                </div>
            </div>
            <div class="form-color-input mt-2">
                <label class="label-primary" for="tel">เบอร์โทรศัพท์</label>
                <b-form-input type="text" placeholder="กรอกเบอร์โทรศัพท์" v-model="inputGroup.tel" :class="{ 'is-invalid': $v.inputGroup.tel.$error }"/>
                <div v-if="$v.inputGroup.tel.$error">
                    <p v-if="!$v.inputGroup.tel.required" class="invalid-feedback d-block">กรุณากรอกเบอร์โทรศัพท์</p>
                    <p v-if="!$v.inputGroup.tel.minLength" class="invalid-feedback d-block">กรุณากรอกเบอร์โทรศัพท์อย่างน้อย 9 ตัว</p> 
                </div>
            </div>
            <div class="form-color-input mt-2">
                <label class="label-primary" for="address">รายละเอียดที่อยู่</label>
                <b-form-textarea
                :class="{ 'is-invalid': $v.inputGroup.address.$error }"
                v-model="inputGroup.address"
                placeholder="กรอกรายละเอียดที่อยู่"
                rows="2"
                max-rows="3"
                ></b-form-textarea>
                <div v-if="$v.inputGroup.address.$error">
                    <p v-if="!$v.inputGroup.address.required" class="invalid-feedback d-block">กรุณากรอกรายละเอียดที่อยู่</p>
                </div>
            </div>
            <div class="mt-2">
                <div class="mt-3">
                    <div class="box-model form-control d-flex justify-content-between align-items-center cursor-pointer" @click="changeSlideOnsearch">
                        <div class="cursor-pointer">
                        {{ inputGroup.formatAddress }}
                        </div>
                        <span class="cursor-pointer">
                            <img :src="iconUrl.iconmore"/>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="px-3 group-input m-group-input">
            <div class="form-color-input">
                <label class="label-primary" for="">
                    หมายเหตุ <span class="text-muted"> ( ถ้ามี )</span>
                </label>
                <b-form-textarea
                    id="textarea"
                    v-model="inputGroup.remark"
                    placeholder="ข้อความที่ระบุจะแสดงบนใบปะหน้า"
                    maxlength="100"
                    rows="2"
                    max-rows="3"
                ></b-form-textarea>
                <div class="position-relative text-end">
                    <span class="remark-length">{{ inputGroup.remark.length }} / 100</span>
                </div>
            </div>
        </div>
      <div class="d-flex flex-column px-3 m-group-input group-input">
        <b-button variant="line-primary" class="mt-2" block @click="actionEditAddress">บันทึก</b-button>
        <b-button variant="outline-line-primary" class="mt-2 hover-button-primary" block @click="closeTab">กลับสู่ Chat</b-button>
      </div>
    </div>
    <div v-else :class="Page.one === true ? 'dialog-reverse' : 'dialog'">
        <label for="ที่อยู่">ค้นหาที่อยู่</label>
        <thai-address-input type="search"
            v-model="inputGroup.formatAddressSelect"
            input-class="form-control"
            @selected="onSearched"
            placeholder="กรอกที่อยู่ของคุณที่นี่"
            >
        </thai-address-input>
        <div class="image-empty w-100 mt-5">
            <img src="../../assets/images/line/emptyaddress.png" alt="">
        </div>
        <div>
            <h1 class="header-empty">
                ค้นหาที่อยู่ของคุณ
            </h1>
            <h3 class="description-empty">
                เช่น ตำบล , อำเภอ , จังหวัด , รหัสไปรษณีย์
            </h3>
        </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
const context_line = JSON.parse(localStorage.getItem('context_line'))
export default {
    metaInfo: {
      title: 'แก้ไขที่อยู่ผู้รับ',
    },
    data() {
        return {
            Page: {
                one: true,
                two: false,
            },
            address: [],
            inputGroup: {
                name: '',
                tel: '',
                formatAddress: '',
                formatAddressSelect: '',
                address: '',
                state: '',
                province: '',
                postcode: '',
                district: '',
                remark: ''
            },
            dismissCountDown: 0,
            messageAlert: '',
            iconUrl : {
                iconmore: require('../../assets/icon/iconmore.svg')
            },
        }
    },
    validations: {
        inputGroup: {
            name: { required },
            tel: { required, minLength: minLength(9) },
            address: { required },
            state: { required },
            province: { required },
            postcode: { required },
            district: { required }
        },
    },
    mounted() {
        this.$liff.init({
            liffId: context_line.liffId
        })
        this.getConsign();
        if(this.$route.query.typeSelect === 'oneItemStageone') {
            if(!this.$route.query.draftId) {
                return this.$router.push({ path: '/location/timeout' })
            }
        }
    },
    methods: {
        showAlert() {
            this.dismissCountDown = 5
        },  
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        async actionEditAddress() {
            this.$v.inputGroup.$touch();
            if( this.$v.inputGroup.$invalid ) {
                return false
            }
            const consignId = this.$route.query.consignId
            const getProfile = JSON.parse(localStorage.getItem('profile_line'))
            const body = {
                access_token: localStorage.getItem('access_token_line'),
                to_name: this.inputGroup.name,
                to_tel: this.inputGroup.tel,
                to_address: this.inputGroup.address,
                to_state: this.inputGroup.state,
                to_district: this.inputGroup.district,
                to_province: this.inputGroup.province,
                to_postcode: this.inputGroup.postcode,
                remark: this.inputGroup.remark,
                userId: getProfile.sub,
                typeSelect: this.$route.query.typeSelect ? this.$route.query.typeSelect : ''
            }
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }
            await this.$http.post(this.$API_URL + `/line/edit/consign/${consignId}`, body, headers).then((res) => {
                const status = res.data.status 
                if(!status) {
                    this.showAlert()
                    this.messageAlert = "เกิดข้อผิดพลาดกรุณาตรวจสอบอีกครั้ง"
                    return false
                }
                if(this.$route.query.typeSelect === 'oneItemStageone') {
                    if(!this.$route.query.draftId) {
                        return this.$router.push({ path: '/location/timeout' })
                    }
                    let queryParamsend = '?draftId=' + this.$route.query.draftId + '&typeSelect=' + this.$route.query.typeSelect
                    queryParamsend = encodeURIComponent(queryParamsend)
                    const queryParam = `&queryparams=${queryParamsend}`
                    this.$liff.openWindow({
                        url: `https://liff.line.me/${context_line.liffId}?liffId=${context_line.liffId}&redirectPath=cancelorder`+queryParam,
                        external: false,
                    })
                    
                }else {
                    this.$liff.closeWindow()
                }
            })
        },
        async closeTab() {
            await this.$liff.closeWindow();
        },
        changeSlideOnsearch() {
            this.Page.one = false;
            this.Page.two = true;
        },
        onSearched(address) {
            this.inputGroup.state = address.subdistrict;
            this.inputGroup.district = address.district;
            this.inputGroup.province = address.province;
            this.inputGroup.postcode = address.postalCode;
            this.inputGroup.formatAddress = address['subdistrict'] + '>' + address['district'] + '>' + address['province'] + '>' +address['postalCode']
            this.Page.one = true;
            this.Page.two = false;
            this.formatAddressSelect = ''
        },
        async getConsign() {
            const consignId = this.$route.query.consignId
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }
            await this.$http.post(this.$API_URL + `/line/get/consign/${consignId}`, {
                typeSelect: this.$route.query.typeSelect ? this.$route.query.typeSelect : '',
            },headers).then((res) => {
                const status = res.data.status
                if(!status) {
                    return this.$router.push('/location/timeout')
                }
                this.address = res.data.data
                this.inputGroup.name = this.address.to_name 
                this.inputGroup.tel = this.address.to_tel
                this.inputGroup.address = this.address.to_address
                this.inputGroup.state = this.address.to_state
                this.inputGroup.district = this.address.to_district
                this.inputGroup.province = this.address.to_province;
                this.inputGroup.postcode = this.address.to_postcode;
                this.inputGroup.formatAddress = this.address['to_state'] + '>' + this.address['to_district'] + '>' + this.address['to_province'] + '>' +this.address['to_postcode']
                this.inputGroup.remark = this.address.remark ? this.address.remark  : ''
            })
        }
    }
    
}
</script>